// Contact form (CF7, markup: docs/integration/cf7-formulaire-contact-hp.txt): the Particulier / Professionnel switch adapts the name and message placeholders, as in the mockup
// the Particulier placeholders are the CF7 ones, the Professionnel ones are below
const PRO_PLACEHOLDERS = {
  name: 'Société ou collectivité · votre nom',
  message: 'Parlez-nous de votre projet : type de site, surface, contraintes, échéance…'
}

document.querySelectorAll('.home-contact-form').forEach((form) => {
  const name = form.querySelector('[autocomplete="name"]')
  const message = form.querySelector('textarea')
  const defaults = {
    name: name?.placeholder,
    message: message?.placeholder
  }

  const update = () => {
    const placeholders = form.querySelector('.home-contact-who input[value="Professionnel"]:checked') ? PRO_PLACEHOLDERS : defaults

    if (name) {
      name.placeholder = placeholders.name
    }
    if (message) {
      message.placeholder = placeholders.message
    }
  }

  // WP Rocket delays the scripts until the first interaction, which may already be a click on Professionnel
  update()
  form.addEventListener('change', update)
  // CF7 resets the form after a successful submission: the radios go back to Particulier once the reset is done
  form.closest('form')?.addEventListener('reset', () => setTimeout(update))
})
